<router-outlet></router-outlet>

<div class="sticky-cookie" *ngIf="!isCookiesAccept" data-aos-duration="3000">
  <!-- <div class="row"> -->
  <div class="card"> 
    <div class="content">
      <div class="cancel" (click)="setCookie()">Decline & Continue  <span style="color: #027ea7;"> &#x2192;</span>
        </div>
<!-- &#x2715; -->
      <h5>CONSENT NOTICE</h5>

      <p>
        With your agreement, we use cookies or similar technologies to store,
        access, and process personal data like your visit to this website, IP
        addresses, and cookies identifiers. You can withdraw your consent or
        object to data processing based on a legitimate interest at any time by
        clicking on <a href="cookies-policy" (click)="setCookie()">“Learn More”</a> or in our <a href="privacy-policy" (click)="setCookie()">“Privacy Policy”</a> on this website.
      </p>
      <p>
        <b>We process data for the following purposes:</b> Advertisement cookies,
        analytical cookies, personalized advertising and content, advertising and content measurement,
        audience research and services development, precise geolocation data
        and identification through device scanning, store and/or access information
        on a device.
      </p>
      <a  href="cookies-policy" (click)="setCookie()"
        ><u>Learn more</u><i class="fa fa-angle-right ml-2"></i
      ></a>
      <br /><br />
      <div>
        <button class="button" type="button" (click)="saveCookiesSettings(1)">
          Agree & Continue
        </button>
        <!-- <button class="decline" type="button" (click)="saveCookiesSettings()">
          Decline
        </button> -->
      </div>
    </div>
  </div>
  <!-- <button (click)="deleteAll()">Delete All</button> -->
  <!-- </div> -->
</div>

<!-- <div class="sticky-cookie" *ngIf="!isCookiesAccept">
  <div class="row">
    <div>
      <div class="card cookie">
        <div class="cancel" (click)="saveCookiesSettings()">&#x2715;</div>
        <br />
        <div class="">
          <table class="cookies-table">
            <tr>
              <th>#</th>
              <th>Cookie Name</th>
              <th>Action</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Necessary Cookies</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 1)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>Google Marketing Platform</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 2)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>Performance Cookies</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 3)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>Analytics Cookies</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 4)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Functional Cookies</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 5)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>Cookies Policy Note</td>
              <td>
                <div class="button r" id="button-1">
                  <input
                    type="checkbox"
                    class="checkbox"
                    (click)="check($event, 0)"
                  />
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </td>
            </tr>
          </table>
          <br />
          <div class="ml-2 mr-2">
            <span
              >We use third party cookies to personalize content, ads and&nbsp;
              analyze site traffic.<br /></span
            ><a class="learn-more" href="#"
              >Learn more<i class="fa fa-angle-right ml-2"></i
            ></a>
          </div>
        </div>
        <div>
          <button class="button" type="button" (click)="saveCookiesSettings()">
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</div> -->
